import React from 'react';

import { Button, Icon } from '@rbilabs/components-library';

const MenuCardButton = props => (
  <Button {...props} startIcon={<Icon icon="next" height="16px" width="16px" aria-hidden />} />
);

export default MenuCardButton;
